import React, { PropTypes } from 'react';
import Slider from 'react-slick';

let CategorySlider = React.createClass({

  getInitialState: function() {
    return {
      entries: []
    };
  },

  componentDidMount: function() {
    this.setEntries();
  },

  loadEntries: function(cb) {
    let filters = {
      page: 1,
      perpage: 1000,
      sort: 'update_stamp',
      order: 'DESC'
    };

    apiConn.doCall('carouselhandler', 'query', {filters: filters}, (status, data) => {
      if (status) {
        cb(null, data);
      } else {
        cb('failed to load entries', null);
      }
    });
  },

  setEntries: function() {
    this.loadEntries(function(err, res) {
      if (err) {
        console.log('LOAD ERROR', err);
      } else {
        this.setState({
          entries: res.data
        });
      }
    }.bind(this));
  },

  render () {
    let settings = {
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            centerPadding: '55px',
            variableWidth: false
          }
        },
        {
          breakpoint: 640,
          settings: {
            centerPadding: '25px',
            variableWidth: false
          }
        }
      ]
    };

    let entries = this.state.entries;
    if (entries.length === 1) {
      entries.push(entries[0]);
    }

    const sliderItems = entries.map((entry, index) => {
      return (
        <div key={index}>
          <a href={entry.url}>
            <picture>
              <source srcSet={'/bilder/carousel_small-original/' + entry.id + '/carousel.jpg'} media="(max-width: 639px)" />
              <source srcSet={'/bilder/carousel_large-original/' + entry.id + '/carousel.jpg'} />
              <img src={'/bilder/carousel_large-original/' + entry.id + '/carousel.jpg'} />
            </picture>
          </a>
        </div>
      );
    });

    return (
      <div>
        <div>
          {sliderItems.length > 0 ? (
            <Slider {...settings}>
              { sliderItems }
            </Slider>
          ) : false}
        </div>
      </div>
    );
  }
});


module.exports = CategorySlider



// WEBPACK FOOTER //
// ./src/scripts/components/slider.js